{
  "validation.maxAttachments": "Kun {{max}} vedlegg er tillatt.",
  "validation.minAttachments": "minst {{min}} vedlegg må legges ved",
  "validation.maxAttachmentSize": "Vedleggene dine kan ikke være større enn {{max}} megabyte.",
  "validation.attachmentListItemRequired": "Vennligst legg ved en fil for \"{{category}}\".",
  "validation.attachmentListItemMaxAttachments": "kun {{max}} vedlegg er tillatt for \"{{category}}",
  "validation.attachmentListItemMaxAttachmentSize": "{{category}}-vedlegg kan ikke være større enn {{max}} megabyte.",
  "attachment.bsoCategory.DiagnosticReport": "Diagnoserapport",
  "attachment.bsoCategory.InvoiceDocument": "Fakturadokument",
  "attachment.bsoCategory.ShippingDocument": "Fraktdokument",
  "attachment.bsoCategory.Letter": "Brev",
  "attachment.bsoCategory.PictureReference": "Bildereferanse",
  "attachment.bsoCategory.BugReport": "Feilrapport",
  "attachment.bsoCategory.Other": "Annet",
  "attachment.bsoCategory.Unclassified": "Uklassifisert",
  "attachment.bsoCategory.ServiceForms": "Serviceskjema",
  "attachment.bsoCategory.RegistrationDocument": "Registreringsdokument",
  "attachment.bsoCategory.ShopInside": "Bilde av butikkinteriør",
  "attachment.bsoCategory.ShopImageMigration": "Flytting av butikkbilder",
  "attachment.bsoCategory.ShopImage": "Bilde av butikkfasade",
  "attachment.uploadButton": "Last opp {{category}}",
  "attachment.uploadDropdown": "Last opp en fil"
}